import React from 'react'

const ServiceArea = ({ alignment, className, component, children }) => {
    const classes = `service__section${
        alignment ? ` service--section${alignment}` : ''
    }${className ? ' ' + className : ''}`
    return (
        <div className={classes}>
            <article className="contentContainer service__content">
                {component ? component : children}
            </article>
        </div>
    )
}

export default ServiceArea
